import React from 'react';
import { config } from 'src/config';
export const Version = () => { var _a; return React.createElement(React.Fragment, null, (_a = config.releaseVersion) !== null && _a !== void 0 ? _a : 'N/A'); };
